import React from 'react';
import { useQuery } from '@tanstack/react-query';

import type { BlackAndWhiteListDetail, UseQueryWrapper } from '../../../types';

import type { GetBlackAndWhiteListDetailsParams } from '../../../Domain/Dashboard/Services';
import { dashboardService } from '../../../Domain/Dashboard/Services';

import { useSnakeBar } from '../../useSnakeBar';

type GetBlackAndWhiteListQueryVariables = GetBlackAndWhiteListDetailsParams;

type GetBlackAndWhiteListQueryResultData = {
  data: BlackAndWhiteListDetail[];
  totalCount: number;
};

const queryFn = (variables: GetBlackAndWhiteListQueryVariables) => async () => {
  const response = await dashboardService.getBlackAndWhiteListDetails(variables);
  return response.data;
};

const QUERY_KEY = 'getBlackAndWhiteListDetails';

export const useDashboardGetBlackAndWhiteListDetailsQuery: UseQueryWrapper<
  GetBlackAndWhiteListQueryResultData,
  GetBlackAndWhiteListQueryVariables
> = ({ variables, options }) => {
  const { showErrorSnakeBar } = useSnakeBar();

  const onError = React.useCallback(() => {
    showErrorSnakeBar({ method: QUERY_KEY });
  }, [showErrorSnakeBar]);

  const select = React.useCallback(data => {
    return {
      data: data['hydra:member'],
      totalCount: data['hydra:totalItems'],
    };
  }, []);

  return useQuery<GetBlackAndWhiteListQueryResultData>([QUERY_KEY, ...Object.values(variables)], queryFn(variables), {
    select,
    onError,
    ...(options || {}),
  });
};
